import React, { useState, useEffect } from 'react';
import { FaComments, FaPlus, FaTimes, FaTrash } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { api } from '../utils/services/api';
import { SERVICE } from '../utils/constants/services';
import Swal from 'sweetalert2';
import styles from './communications.module.css';
import CommunicationsModal from './communicationsModal';
import MessageDetailModal from './messageDetailModal';

export default function Communications() {
    const { userName, communications, setCommunications } = useAuth();
    const [showChat, setShowChat] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState(null);
    const [loading, setLoading] = useState(false);

    const isAdmin = userName && userName.toLowerCase() === 'admin';
    
    // Ordenar mensajes por fecha descendente (más nuevos primero)
    const sortedMessages = [...communications].sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
    });

    const handleLoadMessages = () => {
        setLoading(true);
        api(SERVICE.getCommunications, {}, 'GET')
            .then((data) => {
                if (data.data.data) {
                    setCommunications(data.data.data);
                } else {
                    setCommunications([]);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.log('Error loading messages:', err);
                setLoading(false);
            });
    };

    useEffect(() => {
        if (showChat) {
            handleLoadMessages();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showChat]);

    const handleRefresh = () => {
        handleLoadMessages();
    };

    const handleDeleteMessage = (messageId, messageText) => {
        Swal.fire({
            title: '¿Eliminar comunicado?',
            text: `¿Está seguro de eliminar este comunicado: "${messageText.substring(0, 50)}..."?`,

            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                api(`${SERVICE.deleteCommunication}?id=${messageId}`, {}, 'DELETE')
                    .then((data) => {
                        if (data.data.status) {
                            Swal.fire('Eliminado', 'El comunicado ha sido eliminado', 'success');
                            handleRefresh();
                        } else {
                            Swal.fire('Error', 'No se pudo eliminar el comunicado', 'error');
                        }
                    })
                    .catch((err) => {
                        console.log('Error deleting message:', err);
                        Swal.fire('Error', 'Error al eliminar el comunicado', 'error');
                    });
            }
        });
    };

    const handleOpenMessage = (message) => {
        setSelectedMessage(message);
        setShowDetailModal(true);
    };

    return (
        <>
            <div className={styles.chatContainer}>
                <button
                    className={styles.chatButton}
                    onClick={() => setShowChat(!showChat)}
                    title="Comunicados"
                >
                    <FaComments size={20} />
                    {sortedMessages.length > 0 && (
                        <span className={styles.badge}>{sortedMessages.length}</span>
                    )}
                </button>

                {showChat && (
                    <div className={styles.chatPanel}>
                        <div className={styles.chatHeader}>
                            <h3>Comunicados</h3>
                            <div className={styles.headerActions}>
                                {isAdmin && (
                                    <button
                                        className={styles.addButton}
                                        onClick={() => setShowModal(true)}
                                        title="Nuevo comunicado"
                                    >
                                        <FaPlus />
                                    </button>
                                )}
                                <button
                                    className={styles.closeButton}
                                    onClick={() => setShowChat(false)}
                                >
                                    <FaTimes />
                                </button>
                            </div>
                        </div>

                        <div className={styles.chatContent}>
                            {loading ? (
                                <div className={styles.loading}>Cargando...</div>
                            ) : sortedMessages.length === 0 ? (
                                <div className={styles.emptyState}>
                                    No hay comunicados
                                </div>
                            ) : (
                                <div className={styles.messagesList}>
                                    {sortedMessages.map((message, index) => (
                                        <div key={index} className={styles.messageItem}>
                                            <div 
                                                className={styles.messageContent}
                                                onClick={() => handleOpenMessage(message)}
                                            >
                                                <div className={styles.messageMeta}>
                                                    <strong>{message.userName}</strong>
                                                    <span className={styles.messageDate}>
                                                        {new Date(message.date).toLocaleDateString('es-MX')}
                                                    </span>
                                                </div>
                                                <div className={styles.messageText}>
                                                    {message.message && message.message.length > 100 
                                                        ? `${message.message.substring(0, 100)}...` 
                                                        : message.message}
                                                </div>
                                            </div>
                                            {isAdmin && (
                                                <button
                                                    className={styles.deleteButton}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDeleteMessage(message.id, message.message);
                                                    }}
                                                    title="Eliminar comunicado"
                                                >
                                                    <FaTrash />
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className={styles.chatFooter}>
                            <button
                                className={styles.refreshButton}
                                onClick={handleRefresh}
                            >
                                Actualizar
                            </button>
                        </div>
                    </div>
                )}
            </div>

            <CommunicationsModal
                show={showModal}
                setShow={setShowModal}
                onSuccess={handleRefresh}
            />
            <MessageDetailModal
                show={showDetailModal}
                setShow={setShowDetailModal}
                message={selectedMessage}
            />
        </>
    );
}
